import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import React from "react";

export function ShareDialog({ isOpen, onClose, shareUrl }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share Landofile</DialogTitle>
          <DialogDescription>Copy this URL to share your Landofile configuration:</DialogDescription>
        </DialogHeader>
        <div className="flex items-center space-x-2">
          <input
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            value={shareUrl}
            readOnly
            onClick={(e) => e.target.select()}
          />
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
            onClick={() => {
              navigator.clipboard.writeText(shareUrl);
              onClose();
            }}
          >
            Copy
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
